import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { mainSiteUrl } from "@/mocks/categories";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 text-foreground-950">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-links-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight">{t("brand")}</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              {t("footer.tagline")}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("footer.explore")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-foreground-600 transition-colors hover:text-foreground-950">
                  {t("footer.home")}
                </Link>
              </li>
              <li>
                <Link to="/#categories" className="text-foreground-600 transition-colors hover:text-foreground-950">
                  {t("footer.categories")}
                </Link>
              </li>
              <li>
                <Link to="/usfans-spreadsheet-guide" className="text-foreground-600 transition-colors hover:text-foreground-950">
                  {t("footer.guide")}
                </Link>
              </li>
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-foreground-600 transition-colors hover:text-foreground-950">
                  {t("footer.mainSite")}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("footer.legal")}</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <a href="#" className="text-foreground-600 transition-colors hover:text-foreground-950">
                  {t("footer.privacy")}
                </a>
              </li>
              <li>
                <a href="#" className="text-foreground-600 transition-colors hover:text-foreground-950">
                  {t("footer.terms")}
                </a>
              </li>
              <li>
                <a href="#" className="text-foreground-600 transition-colors hover:text-foreground-950">
                  {t("footer.disclaimerTitle")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-background-200 pt-6">
          <p className="text-xs leading-relaxed text-foreground-500">{t("footer.disclaimer")}</p>
          <p className="mt-3 text-xs text-foreground-500">
            © {new Date().getFullYear()} {t("brand")}. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}